"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _commentAdd = _interopRequireDefault(require("@atlaskit/icon/core/comment-add"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesAddCommentIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14 4.187A10.7 10.7 0 0 0 12 4c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716v-.002s-1.563-2.26-.766-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513a6 6 0 0 0-.02-.513h-2.008q.03.254.03.513c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51S8.139 6.003 12 6.003c.695 0 1.366.08 2 .229z"/><rect width="2" height="6" x="17" y="4" rx="1"/><rect width="6" height="2" x="15" y="6" rx="1"/></g></svg>`
}, props, {
  newIcon: _commentAdd.default
}));
MediaServicesAddCommentIcon.displayName = 'MediaServicesAddCommentIcon';
var _default = exports.default = MediaServicesAddCommentIcon;